module.exports = __webpack_public_path__ + "static/media/BarChart.3c4f19b9.svg";